import envDetect from '@tcc/env-detect';

export const BASE_FIELDS_URL = '/static/field-selection-web/';
export const BASE_FIELDS_URL_NEW_ARCH = '/static/field-view/#/field-selection-web/';
export const SCRIPTING_URL = '/variable-rate/';
export const SCRIPTING_PLUGIN_URL = '/static/field-view/#/variable-rate/';
export const PLANTING_REPORT_URL = '/static/field-view/#/reports/planting-report';
export const APPLICATION_REPORT_URL = '/static/field-view/#/reports/application-report';
export const FHA_URL = '/field-health/';

const PROD_FIELDVIEW_URL = 'https://spatial.fieldviewplus.com';
// TODO: CFVWEB-9538
// updated TEST_FIELDVEIW_URL as spatial-test no longer exist. conditionally should be
// removed once confirmation UI automation is checking for specific env
const TEST_FIELDVIEW_URL = 'https://spatial.fieldviewplus.com';
export const BASE_FIELDVIEW_URL = envDetect.isEnv('production')
  ? PROD_FIELDVIEW_URL
  : TEST_FIELDVIEW_URL;
